import type * as React from 'react';
import { cn } from '@/shared/lib/cn';
import { controlSurface } from '@/shared/ui/input';

/** Multi-line text input; grows with its content. */
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(controlSurface, 'field-sizing-content min-h-24 px-3 py-2 text-base', className)}
      {...props}
    />
  );
}

export { Textarea };
